import { ADD_UNIT, DELETE_UNIT, GET_UNIT, UPDATE_UNIT, GET_ONE_UNIT} from "../types";
  
  const initialState = { list: [], single: null,  pagination: {
    limit: 10,
    nextPage: null,
    totalPages: 1,
    currentPage: 1,
    hasNextPage: false,
    previousPage: null,
    totalProducts: 0,
    hasPreviousPage: false,
  }, };
  
  const reducer = (state = initialState, action) => {
    const { type, payload } = action;
  
    switch (type) {
      case GET_UNIT:
        return { ...state, list: payload.data , pagination: payload.pagination };
  
      case UPDATE_UNIT:
        return {
          ...state,
          list: state.list.map((item) =>
            item.id === payload.id ? payload : item
          ),
        };
  
      case ADD_UNIT:
        return {
          ...state,
          list: [payload, ...state.list],
        };
  
      case DELETE_UNIT:
        return {
          ...state,
          list: state.list.filter((item) => item.id !== payload.id),
        };
  
      case GET_ONE_UNIT:
        return { ...state, single: payload };

      default:
        return state;
    }
  };
  
  export default reducer;
  